/**
 * Constants
 * */
export const moduleName = `locationData`;

/**
 * Reducer
 * */

export default function reducer(state = {}, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const locationDataSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
